import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/EditingPage.css';
import SubNav from '../components/subNav';
import SEO from '../components/SEO';
import { baseUrl } from '../config';



const EditingPage = () => {
  const [recentFiles, setRecentFiles] = useState([
    { id: 1, name: 'Modify the ending animation', imageUrl: '/images/file1.jpg' },
    { id: 2, name: 'Add sound effects', imageUrl: '/images/file2.jpg' },
    { id: 3, name: 'Edit transition scenes', imageUrl: '/images/file3.jpg' },
  ]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadedFile, setUploadedFile] = useState(null);
  const navigate = useNavigate();

  const handleTemplateClick = () => {
    if (selectedFile) {
      navigate('/template', { state: { file: selectedFile } });
    } else {
    }
  };

  const handleEditorClick = () => {
    if (selectedFile) {
      navigate('/edit-options', { state: { file: selectedFile } });
    } else {
    }
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const newFile = {
        id: recentFiles.length + 1,
        name: file.name,
        imageUrl: URL.createObjectURL(file),
      };
      setUploadedFile(newFile);
      setSelectedFile(newFile);
    }
  };

  const handleGoogleDriveUpload = () => {
    const newFile = {
      id: recentFiles.length + 1,
      name: 'Uploaded from Google Drive',
      imageUrl: '/images/new-file.jpg',
    };
    setUploadedFile(newFile);
    setSelectedFile(newFile);
  };

  const handleFileProcessing = () => {
    if (uploadedFile) {
      setRecentFiles([uploadedFile, ...recentFiles.slice(0, 2)]);
      setUploadedFile(null);
    } else {
    }
  };

  const handleCloudUpload = () => {
    const newFile = {
      id: recentFiles.length + 1,
      name: 'Uploaded from Cloud',
      imageUrl: '/images/cloud-file.jpg',
    };
    setUploadedFile(newFile);
    setSelectedFile(newFile);
  };

  return (
    <>
    <SEO
      title="Video Editing"
      description="Edit your film's video content with ProducerBuddy's built-in video editing tools."
      url="https://producerbuddy.pilomation.com/editing"
      robots="noindex, nofollow"
    />
    <SubNav/>
    <div>
      <div className="editing-page">
        {/* AI Assistance Button */}
        <div className="top-buttons">
          <button
            className="top-button templates-button"
            onClick={handleTemplateClick}
            disabled={!selectedFile}
          >
            Templates
          </button>
          <button
            className="top-button editor-button"
            onClick={handleEditorClick}
            disabled={!selectedFile}
          >
            Editor
          </button>
        </div>

        <div className="upload-section">
          <h3>Upload Script/Clips:</h3>
          <div className="upload-buttons">
            <button
              className="upload-button"
              onClick={() => document.getElementById('fileInput').click()}
            >
              Upload from Device 📁
            </button>
            <input
              id="fileInput"
              type="file"
              style={{ display: 'none' }}
              onChange={handleFileUpload}
            />
            <button className="upload-button" onClick={handleGoogleDriveUpload}>
              Google Drive ☁️
            </button>
            <button className="upload-button" onClick={handleCloudUpload}>
              Cloud ☁️
            </button>
          </div>
          {uploadedFile && (
            <div className="uploaded-file-info">
              <p>Uploaded File: {uploadedFile.name}</p>
              <button className="process-button" onClick={handleFileProcessing}>
                Process File
              </button>
            </div>
          )}
        </div>

        <div className="recent-files">
          <h3>Recents</h3>
          <div className="file-list">
            {recentFiles.map((file) => (
              <div
                key={file.id}
                className={`file-card ${selectedFile?.id === file.id ? 'selected' : ''}`}
                onClick={() => setSelectedFile(file)}
              >
                <img src={file.imageUrl} alt={file.name} />
                <p>{file.name}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default EditingPage;
